<template>
    <div class="xcard">
        <h4 class="text-center" style="margin-top:0"> Contactos de la feria </h4>
        <button v-if="!$store.state.isonlyread" class="pull-right btn btn-link btn-xs ml-4" data-toggle="modal" data-target="#modal-contacto" @click="editarcontacto(null)"><span class="glyphicon glyphicon-file"></span> Registrar contacto</button>

        <div style="background:#E9F2F7;padding:0 8px 8px 8px">
            <p class="text-primary" style="margin-bottom:0"><small>filtrar contactos por fecha de visita y datos del contacto:</small></p>
            <div class="row"> 
                <div class="col-sm-12" style="margin-bottom:0;padding-bottom:0">
                    <div class="form-group">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon"><span class="text-danger">*</span> Desde:</div>
                            <Fechas :model="fechas" :valueto="'fecha_ini'" :default="fechas.fecha_ini" />
                            <div class="input-group-addon"><span class="text-danger">*</span> Hasta:</div>
                            <Fechas :model="fechas" :valueto="'fecha_fin'" :default="fechas.fecha_fin" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="$store.state.getContactos">
                <div class="col-sm-12" style="margin-bottom:0;padding-bottom:0">
                    <div class="form-group">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Buscar:</div>
                            <input type="text" v-model.trim="search" :placeholder="txtsearch" class="form-control" style="min-height:34px!important" />
                            <div v-show="idcargo == 1 || isperm" class="input-group-addon">Asesor:</div>
                            <UsuariosActivos v-show="idcargo != 13" :models="asesorsel" :multiple="false" :xonlyasesores="true" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-sm">
                            <div class="input-group-addon">Canal:</div>
                            <multiselect
                                class="form-control form-group-sm"
                                style="width:100%"
                                :options="canales"
                                v-model="canal"
                                track-by="id"
                                label="text"
                                :searchable="true"
                                :close-on-select="true"
                                :multiple="false" 
                                :show-labels="false"
                                placeholder="Seleccione el canal"
                            />
                        </div>
                    </div>
                    <label v-show="idcargo == 1 || isperm"> <input type="checkbox" v-model="listartodos" /> <small>Listar todos los contactos.</small> </label>
                </div>
            </div> 

            <div class="row" v-if="$store.state.getContactos">
                <div class="col-sm-8" >
                    <button class="btn btn-azul center-block" style="color:white" type="button" @click="btnBuscar()">Filtrar contactos</button>
                </div> 
                <div class="col-sm-2 text-right" >
                    <button class="btn cyan darken-3 center-block" style="color:white" type="button" @click="openReporteF()">Reportes </button>
                </div>
            </div>

        </div>
        <hr />

        <p class="text-center">
            <small>{{ txtresultadosearch }}</small>
        </p>
        <p class="text-center">{{ msg }}</p>
        <input v-show="contactos.length > 0" type="text" v-model="buscar" class="form-control" placeholder="Buscar en la tabla..." />
        <!-- <button v-show="contactos.length > 0" class="btn btn-danger btn-sm" @click="eliminarseleccionados()">Eliminar seleccionados</button> -->
        <button :disabled="$store.state.isonlyread" v-show="contactos.length > 0" class="btn btn-sm btn-link" @click="tableToExcel('table', 'Lorem Table')"><span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL</button>
        <div class="table-responsive">
            <table v-show="contactos.length > 0" ref="table" class="table table-condensed table-striped table-hover" id="midatatable" summary="lorem ipsum sit amet" rules="groups" frame="hsides">
                <caption v-show="false">
                    Reporte de contactos:
                    {{
                        nom_us
                    }}, DESDE
                    {{
                        fechas.fecha_ini
                    }}
                    AL
                    {{
                        fechas.fecha_fin
                    }}
                </caption>

                <thead style="background:#00264E;">
                    <tr class="white--text">
                        <th>Nro</th>
                        <th>Acciones</th>
                        <th>Asesor</th>
                        <th>Fecha Registro</th>
                        <th>Carnet</th>
                        <th>Nombres</th>
                        <th>Apellido 1</th>
                        <th>Apellido 2</th>
                        <th>Telefono</th>
                        <th>Correo</th>
                        <th>Fecha Visita</th>
                        <th>Ciudad</th>
                        <th>Estado</th>
                        <th>Intereses</th>
                        <th>Profesion</th>
                        <th>Empresa</th>
                        <th>Direccion</th>
                        <th>Observacion</th>
                        <!-- <th>Latitud</th>
                        <th>Longitud</th> -->
                    </tr>
                </thead>

                <tbody>
                    <tr :key="ind" v-for="(e, ind) in contactos">
                        <td :title="'ID:' + e.id">
                            <small> {{ ind + 1 }} </small>
                        </td> 
                        <td>
                            <input v-show="e.id" class="manito" type="checkbox" v-model="e.checkbox" />
                            <button v-show="e.id" :disabled="noeditar" class="btn btn-link btn-xs ml-4" title="Editar contacto" data-toggle="modal" data-target="#modal-contacto" @click="editarcontacto(e)"><span class="glyphicon glyphicon-pencil"></span></button>
                        </td>
                        <td>
                            <small> {{ e.asesor }} </small>
                        </td>
                        <td>
                            <small> {{ e.fecha_registro }} </small>
                        </td>
                        <td>
                            <small> {{ e.numero_documento }} </small>
                        </td>
                        <td>
                            <small> {{ e.nombres }} </small>
                        </td>
                        <td>
                            <small> {{ e.primer_apellido }} </small>
                        </td>
                        <td>
                            <small> {{ e.segundo_apellido }} </small>
                        </td>
                        <td class="manito text-primary" title="Abrir WhatsApp" @click="openwhatsapp(e)">
                            <small>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                    <path
                                        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967c-.273-.099-.471-.148-.67.15c-.197.297-.767.966-.94 1.164c-.173.199-.347.223-.644.075c-.297-.15-1.255-.463-2.39-1.475c-.883-.788-1.48-1.761-1.653-2.059c-.173-.297-.018-.458.13-.606c.134-.133.298-.347.446-.52c.149-.174.198-.298.298-.497c.099-.198.05-.371-.025-.52c-.075-.149-.669-1.612-.916-2.207c-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372c-.272.297-1.04 1.016-1.04 2.479c0 1.462 1.065 2.875 1.213 3.074c.149.198 2.096 3.2 5.077 4.487c.709.306 1.262.489 1.694.625c.712.227 1.36.195 1.871.118c.571-.085 1.758-.719 2.006-1.413c.248-.694.248-1.289.173-1.413c-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214l-3.741.982l.998-3.648l-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884c2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"
                                        fill="#009800"
                                    />
                                </svg>
                                {{ e.telefono }}
                            </small>
                        </td>
                        <td>
                            <small> {{ e.correo }} </small>
                        </td>
                        <td>
                            <small> {{ e.fecha_visita }} </small>
                        </td>
                        <td>
                            <small> {{ e.ciudad }} </small>
                        </td>

                        <td>
                            <select v-model="e.estado" class="form-control" :style="coloresdeestado(e.estado)" @change="actualizar(e)">
                                <option v-for="(x, ind) in estadoscontactos" :key="ind" :value="x">
                                    <small> {{ x }} </small>
                                </option>
                            </select>
                        </td>
                        <td>
                            <small> {{ mergetextintereses(e.intereses) }} </small>
                        </td>
                        <td>
                            <small> {{ e.profesion }} </small>
                        </td>
                        <td>
                            <small> {{ e.empresa }} </small>
                        </td>
                        <td>
                            <small> {{ e.direccion }} </small>
                        </td>
                        <td>
                            <small> {{ e.observacion }} </small>
                        </td> 
                        <!-- <td>
                            <small> {{ e.latitud }} </small>
                        </td>
                        <td>
                            <small> {{ e.longitud }} </small>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>

        <button v-show="contactos.length > 15" class="btn btn-danger btn-sm" @click="eliminarseleccionados()">Eliminar seleccionados</button>

        <notifications group="auth" position="bottom right" />
        <Modal :padre="contactosel" :listado="contactos" v-on:success="getMisContactos" />

        <Report ref="refReport" />
        <Report2 ref="refReport2" />
        <Report3 ref="refReport3" />
        <ReportFeria ref="refReportFeria" />
    </div>
</template>

/*
<style>
.table th,
.table td {
    white-space: nowrap;
}
</style>
*/

<script>
import { error } from "@/components/Utils.js";
import UsuariosActivos from "@/components/AUsuariosActivos2";
import Fechas from "@/components/AFecha";
import Modal from "@/components/AModal-contactoFeria";
import { getheadersrest } from "@/components/Utils";
import gql from "graphql-tag";
import Report from '@/components/AModal-reporteFeria.vue'
import Report2 from '@/components/AModal-reporteFeria2.vue'
import Report3 from '@/components/AModal-reporteFeria3.vue'
import ReportFeria from '@/components/reportes_feria/xreportemodal.vue'

export default {
    components: { UsuariosActivos, Fechas, Modal,Report,Report2,Report3, ReportFeria },
    data() {
        return {
            // EXCEL
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64: function(s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function(s, c) {
                return s.replace(/{(\w+)}/g, function(m, p) {
                    return c[p];
                });
            },
            // END EXCEL
            txtsearch: "Buscar por carnet, nombre, profesion, ciudad o interes...",
            txtresultadosearch: "",
            listartodos: false,
            noeditar: true,
            msg: "",
            buscar: "",
            nom_us: "",
            search: null,
            contactos_size: "",
            asesorsel: { usuarios: {} },
            contactosel: {},
            fechas: { fecha_ini: "", fecha_fin: "" },
            contactos: [],
            estadoscontactos: ["En Proceso", "Interesado", "Convertido", "Archivado", "No Calificado"], // por defecto de cca
            idcargo: 13, //por defecto id asesor cargo
            isperm:false,
            canales:[
                {id:1, text:'FEXPO CRUZ'},
                {id:2, text:'FEXPO SUCRE'},
                {id:3, text:'EXPOSUR'},
            ],
            canal: null,
        };
    },
    watch: {
        "$store.state.DATA_USER.cargo": function() {
            if (this.$store.state.DATA_USER.cargo) {
                this.idcargo = this.$store.state.DATA_USER.cargo.id; 
                this.permitido();
            }
            this.getMisContactos();
        },
        "$store.state.DATA_USER": function() {
            this.gen_nom_us();
        },
        buscar: function() {
            this.myFunction1(this.buscar);
        },
    }, 
    methods: {
        tableToExcel(table, name) {
            if (!table.nodeType) table = this.$refs.table.cloneNode(true);
            var row = table.rows;
            for (var j = 0; j < row.length; j++) {
                row[j].deleteCell(1);
            } // elimina la columna 1
            var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
            var link = document.createElement("a");
            link.download = "contactos.xls";
            link.href = this.uri + this.base64(this.format(this.template, ctx));
            link.click();
        },
        permitido(){
            const a = this.$store.state.DATA_USER.id;
            this.isperm = a == 14401 || a == 1569 || a == 75939; 
        },

        openReporte(){
            this.$refs.refReport.openmodal(this.contactos);
        },
        openReporte2(){
            this.$refs.refReport2.openmodal(this.contactos);
        },
        openReporte3(){
            this.$refs.refReport3.openmodal(this.contactos);
        },
        openReporteF(){
            this.$refs.refReportFeria.openmodal(this.contactos);
        },
        gen_nom_us() {
            var data_user = this.$store.state.DATA_USER;
            if (!data_user) return;
            if (!data_user.seg_apellido) data_user.seg_apellido = "";
            this.nom_us = data_user.nombres + " " + data_user.pri_apellido + " " + data_user.seg_apellido;
        },
        estadosfromexcel(estado) {
            // agrega los estados subidos por esam
            if (!this.estadoscontactos.includes(estado)) {
                this.estadoscontactos.push(estado);
            }
        },
        estadosfromexcelremove(texto) {
            this.estadoscontactos = this.estadoscontactos.filter(function(value) {
                return value != texto;
            });
        },
        coloresdeestado(estado) {
            if (estado == "En Proceso") return "min-width:180px;background:#46BCC6;color:black;border: solid 1px #46BCC6";
            else if (estado == "Interesado") return "min-width:180px;background:#01FFFF;color:black;border: solid 1px #01FFFF";
            else if (estado == "Convertido") return "min-width:180px;background:#01FF00;color:black;border: solid 1px #01FF00";
            else if (estado == "Archivado") return "min-width:180px;background:#999999;color:black;border: solid 1px #999999";
            else if (estado == "No Calificado") return "min-width:180px;background:#C1362E;color:white;border: solid 1px #C1362E";
            else return "min-width:180px;background:#FFFFFF;color:black;border: solid 1px #black";
        },
        isFechasValidas() {
            var fi = this.fechas.fecha_ini;
            var ff = this.fechas.fecha_fin;
            var f1 = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(fi);
            var f2 = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(ff);
            return f1 && f2;
        },
        parseFecha(f) {
            if (!f) return "";
            let fs = f.split("-");
            return fs[2] + "/" + fs[1] + "/" + fs[0];
        },
        btnBuscar() {
            this.getMisContactos();
        },
        editarcontacto(c) {
            this.contactosel = c;
        },
        mergetextintereses(intereses) {
            if (!intereses) return "-";
            var txt = "";
            intereses.forEach(function(e) {
                txt += e.nombre + ", ";
            });
            if (txt.length > 0) {
                txt = txt.substring(0, txt.length - 2);
            }

            return txt;
        },
        getMisContactos() {
            let idasesor = this.$store.state.DATA_USER.id;
            if (this.asesorsel.usuarios && this.asesorsel.usuarios.id) {
                idasesor = this.asesorsel.usuarios.id;
            }
            if (!this.isFechasValidas()) {
                this.$notify(error("Error de Fechas", "Ingrese el rango de fechas"));
                return;
            }
            const vue = this;
            let myHeaders = getheadersrest();
            /*var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");*/

            let body = {};
            if (!this.listartodos) body.asesor_id = idasesor; // esto lista todos y confunde al no saber de quien es
            //body.asesor_id = idasesor;

            if (this.search && this.search.length > 0) body.search_text = this.search;
            body.fecha_inicio = this.parseFecha(this.fechas.fecha_ini);
            body.fecha_fin = this.parseFecha(this.fechas.fecha_fin);
            body.canal_id = this.canal.id;
            // delete body.asesor_id;

            var raw = JSON.stringify(body);
            vue.contactos = [];
            this.msg = "Cargando datos...";
            this.txtresultadosearch = "";
            window.console.log("CONTACTOS: ", raw, this.asesorsel.usuarios);

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const asesores = new Set();

            fetch(process.env.VUE_APP_API_REST + "/api/esam/contacto/search", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.error) {
                        vue.contactos = [];
                        vue.msg = result.error;
                    } else {
                        result.forEach(function(e) {
                            vue.estadosfromexcel(e.estado);
                            e.asesor = "--";
                            asesores.add(e.asesor_id)
                        });
                        vue.contactos = result.reverse();
                        vue.msg = "";
                        vue.getDatosAsesores(asesores);
                        vue.texto();
                    }
                })
                .catch(() => {
                    vue.msg = "";
                    // window.console.log('error', error)
                });
        },
        async getDatosAsesores(ids){
            const array = Array.from(ids);

            for(let i=0;i<array.length;i++){
                let sq = gql`query{ getPersona(id:${array[i]}) {id nombres pri_apellido seg_apellido} }`;
                const res = await this.$apollo.query({ query: sq }).then(({ data }) => data.getPersona)
                // window.console.log('ids::::',array[i], res);
                if(!res.seg_apellido) res.seg_apellido = '';
                this.contactos.forEach(x=>{
                    if(x.asesor_id == array[i]){
                        x.asesor = `${res.nombres} ${res.pri_apellido} ${res.seg_apellido}`
                    }
                })
            }
        },
        texto() {
            this.txtresultadosearch = "Se han encontrado " + this.contactos.length + ' contactos; desde "' + this.parseFecha(this.fechas.fecha_ini) + " HASTA EL " + this.parseFecha(this.fechas.fecha_fin) + '" ';
            if (this.search) this.txtresultadosearch += ' que contienen la palabra "' + this.search + '"';
        },
        eliminarseleccionados() {
            let iduser = this.$store.state.DATA_USER.id;
            if (this.asesorsel.usuarios.id && this.asesorsel.usuarios.id != iduser) {
                let men = {
                    title: "No puedes eliminar contactos de otro usuario.",
                    body: "Por razones de seguridad, solo puedes eliminar tus propios contactos.",
                };
                this.$dialog
                    .alert(men)
                    .then(function() {})
                    .catch(function() {});
                return;
            }
            var seleccionados = [];
            this.contactos.forEach(function(e) {
                if (e.checkbox) {
                    seleccionados.push(e.id);
                }
            });
            const tam = seleccionados.length;
            if (tam == 0) {
                var message = {
                    title: "No ha seleccionado ningun contacto",
                    body: "",
                };
                this.$dialog
                    .alert(message)
                    .then(function() {})
                    .catch(function() {});
            } else {
                const vue = this;
                const opt = {
                    verification: "eliminar",
                    verificationHelp: 'Escriba "[+:verification]" para eliminar los contacto seleccionados.',
                    okText: "Eliminar contactos",
                    cancelText: "cancelar",
                    backdropClose: false,
                    animation: "bounce",
                    loader: true,
                    type: "hard",
                };
                const message2 = {
                    title: "Confirmar eliminacion de " + tam + " contactos seleccionados.",
                    body: "<br> <b>NOTA:</b> Esta accion es irreversible y no se podran recuperar los contactos eliminados, si no esta seguro de esta accion presione el boton cancelar.",
                };
                this.$dialog
                    .confirm(message2, opt)
                    .then(function(dialog) {
                        vue.eliminarcontactos(dialog, seleccionados);
                    })
                    .catch(function() {});
            }
        },
        eliminarcontactos(dialog, seleccionados) {
            window.console.log(seleccionados);
            const vue = this;
            const requestOptions = {
                method: "DELETE",
                redirect: "follow",
            };

            const solicitudes = [];
            seleccionados.forEach(function(e) {
                solicitudes.push(fetch(process.env.VUE_APP_API_REST + "/api/esam/contacto/id/" + e, requestOptions));
            });

            Promise.all(solicitudes)
                .then(function(responses) {
                    return Promise.all(
                        responses.map(function(response) {
                            return response.json();
                        })
                    );
                })
                .then(function(data) {
                    window.console.log(data);
                    vue.contactos = vue.contactos.filter(function(e) {
                        return !seleccionados.includes(e.id);
                    });
                    vue.texto();
                    dialog.close();
                })
                .catch(() => {
                    // window.console.log('ERROR: ',error);
                    dialog.close();
                });
        },
        openwhatsapp(c) {
            window.open(`${process.env.VUE_APP_API_WHATSAPP}591${c.telefono1}&text=`);
        },
        async actualizar(contacto) {
            let xcontacto = window.Object.assign({}, contacto);
            xcontacto.contacto_id = xcontacto.id;
            delete xcontacto.id;
            for (var propName in xcontacto) {
                if (!xcontacto[propName] || xcontacto[propName] === null || xcontacto[propName] === undefined) {
                    delete xcontacto[propName];
                }
            }
            let myHeaders = getheadersrest();
            /*var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");*/

            var raw = JSON.stringify(xcontacto);
            window.console.log(raw);
            const vue = this;
            this.estadosfromexcel("Actualizando...");
            contacto.estado = "Actualizando...";

            var requestOptions = { method: "PUT", headers: myHeaders, body: raw, redirect: "follow" };
            fetch(process.env.VUE_APP_API_REST + "/api/esam/contacto", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    window.console.log("result:", result);
                    if (result.result) {
                        contacto.estado = xcontacto.estado;
                    } else {
                        contacto.estado = result.error;
                    }
                    vue.estadosfromexcelremove("Actualizando...");
                })
                .catch(() => {
                    // window.console.log('error', error);
                    vue.estadosfromexcelremove("Actualizando...");
                });
        },
        myFunction1(filtro) {
            filtro = filtro.toUpperCase();
            var table, tr, tdd, td, i, j, txtValue;
            table = document.getElementById("midatatable");
            tr = table.getElementsByTagName("tr");

            for (i = 0; i < tr.length; i++) {
                tdd = tr[i].getElementsByTagName("td");
                for (j = 1; j < tdd.length; j++) {
                    td = tdd[j];
                    if (td) {
                        txtValue = td.textContent;
                        if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                            tr[i].style.display = "";
                            break;
                        } else {
                            tr[i].style.display = "none";
                        }
                    }
                }
            }
        },
    },
    mounted() {
        this.canal = this.canales[0];
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if( unidad == 2 ) this.noeditar = true;
        else this.noeditar = false;

        var date = new Date();
        var dia = date.getDate();
        var mes = date.getMonth() + 1;
        if (dia == 1) dia = 2;
        if (dia < 10) dia = "0" + dia;
        if (mes < 10) mes = "0" + mes;
        this.fechas.fecha_ini = date.getFullYear() + "-" + mes + "-01";
        this.fechas.fecha_fin = date.getFullYear() + "-" + mes + "-" + dia;

        if (this.$store.state.CARGO.cargo) {
            this.idcargo = this.$store.state.CARGO.cargo.id;
            this.permitido();
        }

        this.gen_nom_us();
        this.getMisContactos();
    },
};
</script>
